import { __rest } from "tslib";
import React from 'react';
import { tv } from 'tailwind-variants';
const text = tv({
    base: ['font-body'],
    variants: {
        align: {
            left: ['text-left'],
            center: ['text-center'],
            right: ['text-right'],
        },
        size: {
            xxs: ['text-xxs', 'tracking-normal'],
            xs: ['text-xs', 'tracking-normal'],
            sm: ['text-sm', 'tracking-normal'],
            base: ['text-base', 'tracking-normal'],
            lg: ['text-lg', 'tracking-normal'],
            xl: ['text-xl', '-tracking-[0.01em]'],
            '2xl': ['text-2xl', '-tracking-[0.01em]'],
            '3xl': ['text-3xl', '-tracking-[0.02em]'],
            '4xl': ['text-4xl', '-tracking-[0.02em]'],
            '5xl': ['text-5xl', '-tracking-[0.02em]'],
            '6xl': ['text-6xl', '-tracking-[0.02em]'],
            '7xl': ['text-7xl', '-tracking-[0.02em]'],
            '8xl': ['text-8xl', '-tracking-[0.03em]'],
            '9xl': ['text-9xl', '-tracking-[0.03em]'],
        },
        variant: {
            primary: ['text-gray-900', 'dark:text-neutral-50'],
            secondary: ['text-gray-500', 'dark:text-neutral-400'],
            inherit: ['text-inherit'],
            error: ['text-red-500'],
        },
        leading: {
            none: ['leading-none'],
            tight: ['leading-tight'],
            snug: ['leading-snug'],
            normal: ['leading-normal'],
            relaxed: ['leading-relaxed'],
            loose: ['leading-loose'],
        },
        weight: {
            normal: ['font-normal'],
            medium: ['font-medium'],
            semibold: ['font-semibold'],
            bold: ['font-bold'],
        },
    },
    defaultVariants: {
        font: 'body',
        variant: 'secondary',
    },
}, {
    responsiveVariants: true,
    twMerge: false, // https://github.com/nextui-org/tailwind-variants/issues/18
});
/**
  To be used for all text elements
  */
function BtwText(props) {
    const { align, as = 'p', className, leading, size, variant, weight } = props, rest = __rest(props, ["align", "as", "className", "leading", "size", "variant", "weight"]);
    const Component = as;
    return (React.createElement(Component, Object.assign({ className: text({
            align,
            className,
            leading,
            size,
            variant,
            weight,
        }) }, rest)));
}
export { BtwText };
